import { fold } from 'fp-ts/lib/Either'
import { pipe } from 'fp-ts/lib/function'
import * as io from 'io-ts'
import { IMap, Map } from '../../immutable/map'

export const mapPartial = <P extends io.Props>(props: P, name = 'MapPartial') => {
  return new io.Type<IMap<{ [K in keyof P]?: io.TypeOf<P[K]> }>, P>(
    name,
    (u): u is IMap<{ [K in keyof P]?: io.TypeOf<P[K]> }> => Map.isMap(u),
    (u, c) =>
      pipe(
        io.partial(props).validate(u, c),
        fold(
          e => io.failures(e),
          v => pipe(v, Map, io.success)
        )
      ),
    a => a.reduce((accumulator, value, key) => ({ ...accumulator, [key]: value }), {} as P)
  )
}
